<template class="">
  <div class="dash-wrapper">
    <div class="container-fluid px-0">
      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="row mx-1 mt-1">
            <!-- ══════════════ UptimeRobot ══════════════ -->
            <div class="col-md-5 text-center">
              <div
                class="card d-flex align-items-center flex-column"
                style="height: 58vh"
              >
                <span class="font mt-1 mb-1">Monitores UptimeRobot</span>
                <div style="min-height: 17vh; width: 90%">
                  <div
                    id="uptimerobot"
                    style="
                      color: white;
                      border-radius: 4px;
                      font-size: 5vh;
                      min-height: 15vh;
                    "
                    :class="
                      'p-0 d-flex justify-content-center align-items-center bg-' +
                      (monitor !== 'Carregando...'
                        ? status === 2
                          ? 'success'
                          : status === 0
                          ? 'warning'
                          : 'danger'
                        : 'secondary')
                    "
                  >
                    {{ monitor }}
                  </div>
                </div>
                <div
                  class="w-75 d-flex align-items-center justify-content-center"
                  style="margin-top: 1.5vh"
                >
                  <div
                    class="font d-flex mr-4 align-items-center"
                    style="font-size: 3.5vh; line-height: 3vh"
                  >
                    <div
                      class="bg-success ml-1 mr-1"
                      style="border-radius: 100px; height: 3.5vh; width: 3.5vh"
                    ></div>
                    Online
                  </div>
                  <div
                    class="font d-flex align-items-center"
                    style="font-size: 3.5vh; line-height: 3vh"
                  >
                    <div
                      class="bg-danger ml-1 mr-1"
                      style="border-radius: 100px; height: 3.5vh; width: 3.5vh"
                    ></div>
                    Offline
                  </div>
                </div>
                <div
                  class="w-100 mt-4 mb-1 text-center d-flex justify-content-center align-items-center"
                  style="gap: 2vh"
                >
                  <span class="font-low" style="white-space: nowrap"
                    >Sensores<br /><span class="font">{{ total }}</span></span
                  >
                  <span
                    class="font-low text-success"
                    style="white-space: nowrap"
                    >Online<br /><span class="font">{{ online }}</span></span
                  >
                  <span class="font-low text-danger" style="white-space: nowrap"
                    >Offline<br /><span class="font">{{ offline }}</span></span
                  >
                </div>
                <div
                  class="w-100 px-2 mt-2"
                  style="overflow-y: auto; flex: 1; max-height: 16vh"
                >
                  <div
                    v-if="offlineMonitors.length"
                    class="d-flex flex-wrap justify-content-center"
                    style="gap: 5px"
                  >
                    <span
                      v-for="m in offlineMonitors"
                      :key="m.id"
                      class="badge badge-danger"
                      style="
                        font-size: 1.6vh;
                        padding: 4px 8px;
                        white-space: nowrap;
                      "
                    >
                      {{ m.friendly_name }}
                    </span>
                  </div>
                  <div
                    v-else
                    class="text-success text-center"
                    style="font-size: 2.5vh; font-weight: 700; margin-top: 1vh"
                  >
                    <i class="fas fa-check-circle mr-2"></i>Todos os monitores
                    online
                  </div>
                </div>
              </div>
            </div>

            <!-- ══════════════ Próximas Releases ══════════════ -->
            <div class="col-md-7 text-center">
              <div
                class="card d-flex flex-column"
                style="height: 58vh; overflow: hidden"
              >
                <span class="font mt-1 mb-2 text-center">
                  <i
                    class="fas fa-code-branch mr-2"
                    style="font-size: 3.5vh"
                  ></i
                  >Próximas Releases
                </span>

                <div
                  v-if="releasesLoading"
                  class="flex-fill d-flex align-items-center justify-content-center"
                >
                  <i
                    class="fas fa-spinner fa-spin"
                    style="font-size: 5vh; color: #aaa"
                  ></i>
                </div>

                <div
                  v-else-if="!releases.length"
                  class="flex-fill d-flex align-items-center justify-content-center text-muted"
                  style="font-size: 3vh"
                >
                  Nenhuma release planejada
                </div>

                <div v-else class="px-2" style="overflow-y: auto; flex: 1">
                  <table class="table table-sm mb-0" style="color: inherit">
                    <thead>
                      <tr
                        style="font-size: 2vh; border-bottom: 1px solid #3a3f5c"
                      >
                        <th
                          class="text-left pl-2"
                          style="font-weight: 600; color: #aaa; border: none"
                        >
                          Versão
                        </th>
                        <th
                          class="text-left"
                          style="font-weight: 600; color: #aaa; border: none"
                        >
                          Release
                        </th>
                        <th
                          class="text-center"
                          style="font-weight: 600; color: #aaa; border: none"
                        >
                          Status
                        </th>
                        <th
                          class="text-center"
                          style="font-weight: 600; color: #aaa; border: none"
                        >
                          Chamados
                        </th>
                        <th
                          class="text-center"
                          style="font-weight: 600; color: #aaa; border: none"
                        >
                          Deploy Previsto
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="r in releases"
                        :key="r.id"
                        style="border-bottom: 1px solid #2a2f45"
                      >
                        <td
                          class="text-left pl-2 align-middle"
                          style="
                            font-size: 2.5vh;
                            font-weight: 700;
                            white-space: nowrap;
                            border: none;
                          "
                        >
                          <span style="color: #7c9ef8">{{
                            r.version_string
                          }}</span>
                        </td>
                        <td
                          class="text-left align-middle"
                          style="font-size: 2.2vh; border: none"
                        >
                          <span style="opacity: 0.9">{{ r.name }}</span>
                          <small
                            v-if="r.project"
                            style="
                              display: block;
                              font-size: 1.6vh;
                              opacity: 0.5;
                            "
                            >{{ r.project.name }}</small
                          >
                        </td>
                        <td
                          class="text-center align-middle"
                          style="border: none"
                        >
                          <span
                            :class="releaseStatusClass(r.status)"
                            style="font-size: 1.7vh; white-space: nowrap"
                          >
                            {{ releaseStatusLabel(r.status) }}
                          </span>
                        </td>
                        <td
                          class="text-center align-middle"
                          style="
                            font-size: 2.2vh;
                            white-space: nowrap;
                            border: none;
                          "
                        >
                          <span
                            class="badge"
                            :class="
                              r.tickets_count > 0
                                ? 'badge-primary'
                                : 'badge-secondary'
                            "
                            style="font-size: 1.8vh; padding: 4px 10px"
                            >{{ r.tickets_count || 0 }}</span
                          >
                        </td>
                        <td
                          class="text-center align-middle"
                          style="
                            font-size: 2.2vh;
                            white-space: nowrap;
                            border: none;
                          "
                        >
                          <span
                            v-if="r.programacao_inicial_deploy_f"
                            style="font-weight: 600"
                            >{{ r.programacao_inicial_deploy_f }}</span
                          >
                          <span v-else style="opacity: 0.4">—</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- ══════════════ Chamados Aguardando Atendimento ══════════════ -->
            <div class="col-md-12">
              <div
                class="card d-flex justify-content-center"
                style="min-height: 32vh"
              >
                <div class="row w-100 mx-0 d-flex align-items-center" id="sla">
                  <div class="col-12 text-center" v-if="sla.id">
                    <div
                      class="font mb-3 d-flex align-items-center justify-content-center"
                    >
                      Chamados Aguardando Atendimento
                      <span
                        class="badge badge-warning ml-3"
                        style="font-size: 3.5vh; padding: 0.3em 0.7em"
                        >{{ totalChamados }}</span
                      >
                    </div>
                    <div
                      class="d-flex justify-content-center flex-wrap align-items-center"
                      style="gap: 3vh"
                    >
                      <div style="font-size: 3.5vh">
                        <span style="opacity: 0.6">ID:</span>
                        <a
                          :href="`/chamados/${sla.id}`"
                          target="_blank"
                          style="color: #7c9ef8; font-weight: 700"
                        >
                          &nbsp;#{{ sla.id }}
                        </a>
                      </div>
                      <div
                        style="
                          font-size: 3.5vh;
                          max-width: 40vw;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        "
                      >
                        <span style="opacity: 0.6">Título:</span>
                        <strong>&nbsp;{{ sla.title || "—" }}</strong>
                      </div>
                      <div style="font-size: 3.5vh">
                        <span style="opacity: 0.6">Criado em:</span>
                        <strong>&nbsp;{{ sla.created_at_f || "—" }}</strong>
                      </div>
                      <div style="font-size: 3.5vh">
                        <span style="opacity: 0.6">Aguardando há:</span>
                        <strong class="text-warning"
                          >&nbsp;{{ waitingTime(sla.created_at) }}</strong
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 d-flex justify-content-center align-items-center"
                    style="min-height: 26vh"
                    v-else
                  >
                    <div class="font">{{ texto_chamados }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useAppConfig from "@core/app-config/useAppConfig";
import { computed } from "@vue/composition-api";

const STATUS_MAP = {
  planejada:                { label: "Planejada",               cls: "badge badge-secondary" },
  planejamento_atrasado:    { label: "Planejamento Atrasado",   cls: "badge badge-danger" },
  em_desenvolvimento:       { label: "Em Desenvolvimento",      cls: "badge badge-info" },
  desenvolvimento_atrasado: { label: "Desenvolvimento Atrasado",cls: "badge badge-danger" },
  aguardando_testes:        { label: "Aguardando Testes",       cls: "badge badge-info" },
  em_testes:                { label: "Em Testes",               cls: "badge badge-warning" },
  testes_atrasados:         { label: "Testes Atrasados",        cls: "badge badge-danger" },
  aguardando_aprovacao_qa:  { label: "Aguardando Aprovação QA", cls: "badge badge-warning" },
  aguardando_deploy:        { label: "Aguardando Deploy",       cls: "badge badge-primary" },
  deploy_atrasado:          { label: "Deploy Atrasado",         cls: "badge badge-danger" },
  fechada:                  { label: "Fechada",                 cls: "badge badge-danger" },
  finalizada:               { label: "Finalizada",              cls: "badge badge-success" },
};

export default {
  data() {
    return {
      total: 0,
      online: 0,
      offline: 0,
      status: "",
      monitor: "Carregando...",
      uptime: [],
      sla: [],
      texto_chamados: "Carregando...",
      totalChamados: 0,
      releases: [],
      releasesLoading: true,
    };
  },

  computed: {
    offlineMonitors() {
      return this.uptime.filter((m) => m.status === 9);
    },
  },

  setup() {
    const { skin } = useAppConfig();
    skin.value = "dark";
    const isDark = computed(() => skin.value === "dark");
    return { skin, isDark };
  },

  methods: {
    releaseStatusLabel(s) {
      return STATUS_MAP[s] ? STATUS_MAP[s].label : s;
    },
    releaseStatusClass(s) {
      return STATUS_MAP[s] ? STATUS_MAP[s].cls : "badge badge-secondary";
    },

    waitingTime(createdAt) {
      if (!createdAt) return "—";
      const diffMs = new Date() - new Date(createdAt);
      const diffMins = Math.floor(diffMs / 60000);
      const days = Math.floor(diffMins / 1440);
      const hours = Math.floor((diffMins % 1440) / 60);
      const mins = diffMins % 60;
      if (days > 0) return `${days}d ${hours}h`;
      if (hours > 0) return `${hours}h ${mins}min`;
      return `${mins}min`;
    },

    uptimerobot() {
      const self = this;
      axios
        .get(self.$store.state.api + "uptimerobot")
        .then((response) => {
          self.total = response.data.monitors.length;
          self.online = response.data.status.online;
          self.offline = response.data.status.offline;
          self.uptime = response.data.monitors;

          let i = 0;
          const interval = setInterval(() => {
            $("#uptimerobot").fadeIn(1000);
            self.status = response.data.monitors[i].status;
            self.monitor = response.data.monitors[i].friendly_name;

            if (i + 1 === response.data.monitors.length) {
              clearInterval(interval);
              self.uptimerobot();
              i = 0;
            } else {
              i++;
            }
            setTimeout(() => $("#uptimerobot").hide(), 9900);
          }, 10000);
        })
        .catch(() => {
          self.monitor = "Falha ao conectar, tentando novamente...";
          setTimeout(() => {
            self.status = 9;
            self.monitor = "Carregando...";
            self.uptimerobot();
          }, 10000);
        });
    },

    getSla() {
      const self = this;
      axios
        .get(self.$store.state.api + "open-sla")
        .then((response) => {
          self.texto_chamados = "Carregando...";
          self.totalChamados = response.data.length;
          if (response.data.length) {
            let i = 0;
            const interval = setInterval(() => {
              $("#sla").fadeIn(1000);
              self.sla = response.data[i];
              if (i + 1 === response.data.length) {
                clearInterval(interval);
                self.getSla();
                i = 0;
              } else {
                i++;
              }
              setTimeout(() => $("#sla").hide(), 9900);
            }, 10000);
          } else {
            $("#sla").fadeIn(1000);
            self.sla.id = 0;
            self.totalChamados = 0;
            self.texto_chamados = "Não há chamados aguardando atendimento";
            setTimeout(() => self.getSla(), 10000);
          }
        })
        .catch(() => {
          setTimeout(() => {
            self.sla.id = 0;
            self.texto_chamados = "Carregando...";
            self.getSla();
          }, 10000);
        });
    },

    getReleases() {
      const self = this;
      axios
        .get(self.$store.state.api + "releases?paginated=false")
        .then((response) => {
          const all = response.data.data || [];
          self.releases = all
            .filter((r) => r.status !== "finalizada")
            .sort((a, b) => {
              if (!a.programacao_inicial_deploy) return 1;
              if (!b.programacao_inicial_deploy) return -1;
              return (
                new Date(a.programacao_inicial_deploy) -
                new Date(b.programacao_inicial_deploy)
              );
            })
            .slice(0, 10);
          self.releasesLoading = false;
          setTimeout(() => self.getReleases(), 20000);
        })
        .catch(() => {
          self.releasesLoading = false;
          setTimeout(() => self.getReleases(), 30000);
        });
    },

    playSound(volume) {
      const audio = new Audio(
        "https://soundbible.com/mp3/Air%20Plane%20Ding-SoundBible.com-496729130.mp3"
      );
      audio.volume = volume || 0;
      audio.play();
    },
  },

  mounted() {
    const self = this;
    self.uptimerobot();
    self.getSla();
    self.getReleases();

    if (window.Echo?.connector?.channels["calls"]) {
      window.Echo.leave("calls");
    }

    window.Echo.channel("calls")
      .listen("NewCallCreated", () => self.playSound(1))
      .error((error) =>
        console.error("Erro ao escutar o canal 'calls':", error)
      );
  },

  beforeDestroy() {
    if (window.Echo?.connector?.channels["calls"]) {
      window.Echo.leave("calls");
    }
  },
};
</script>

<style>
html,
body {
  overflow: hidden !important;
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
}
.dash-wrapper {
  overflow: hidden !important;
  height: 100vh;
  width: 100vw;
  max-width: 100%;
}
.container-fluid {
  overflow: hidden !important;
  max-width: 100%;
  height: 100vh;
}
.row {
  height: auto;
  max-height: 100vh;
}
.font {
  font-size: 4.5vh;
  font-weight: 700;
}
.font-low {
  font-size: 3.5vh;
  font-weight: 700;
}
.font-lower {
  font-size: 3vh;
  font-weight: 700;
}
@media (max-width: 768px) {
  .font {
    font-size: clamp(1.2rem, 4vw, 2.5rem);
  }
  .font-low {
    font-size: clamp(1rem, 3.5vw, 2rem);
  }
  .font-lower {
    font-size: clamp(0.9rem, 3vw, 1.5rem);
  }
}
</style>
